(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-header-drawer-open]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var d = document.getElementById('HeaderDrawer');
      if(d){ d.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); }
    });
  });
  document.querySelectorAll('[data-header-drawer-close]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var d = document.getElementById('HeaderDrawer');
      if(d){ d.classList.remove('is-open'); }
    });
  });
  document.querySelectorAll('[data-header-acc-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.closest('.header-acc').classList.toggle('is-exp');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
